<template>
  <div class="flex-shrink-0 flex border-t border-green-700 p-4">
    <div class="flex-shrink-0 w-full group block">
      <!-- User account dropdown -->
      <div class="relative inline-block text-left w-full">
        <!-- Dropdown menu toggle, controlling the show/hide state of dropdown menu. -->
        <div>
          <button
            @click="isOpen = !isOpen"
            type="button"
            class="group w-full focus:outline-none"
            id="options-menu"
            aria-haspopup="true"
            aria-expanded="true"
          >
            <div class="flex w-full justify-between items-center">
              <div class="flex items-center justify-between space-x-3">
                <div>
                  <Avatar size="9" />
                </div>
                <div class="flex-1">
                  <h2 class="text-white text-sm leading-5 font-medium">
                    {{ user.cognitoInfo.name }}
                  </h2>
                </div>
              </div>

              <icon
                set="outline"
                name="selector"
                class="h-6 w-6 text-white float-right"
              />
            </div>
          </button>
        </div>
        <!--
            Dropdown panel, show/hide based on dropdown state.

            Entering: "transition ease-out duration-100"
              From: "transform opacity-0 scale-95"
              To: "transform opacity-100 scale-100"
            Leaving: "transition ease-in duration-75"
              From: "transform opacity-100 scale-100"
              To: "transform opacity-0 scale-95"
          -->
        <div v-if="isOpen" class="z-10 origin-bottom right-0 left-0 mt-1">
          <div
            class=""
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="options-menu"
          >
            <div class="py-1">
              <router-link
                :to="{ path: '/notifications' }"
                class="mt-1 group w-full flex items-center pl-2 pr-1 py-2 text-sm leading-5 font-medium text-white rounded-md hover:bg-green-700 focus:outline-none focus:bg-green-700 transition ease-in-out duration-150"
                role="menuitem"
              >
                Notifications
                <span
                  v-if="notifications.length > 0"
                  class="ml-auto inline-block py-0.5 px-3 text-xs leading-4 font-medium rounded-full text-green-800 bg-green-100 transition ease-in-out duration-150 group-hover:bg-green-200 group-focus:bg-green-200"
                >
                  {{ notifications.length }}
                </span>
              </router-link>
              <a
                href="/logout"
                @click.prevent="logout()"
                class="mt-1 group w-full flex items-center pl-2 pr-1 py-2 text-sm leading-5 font-medium text-white rounded-md hover:bg-green-700 focus:outline-none focus:bg-green-700 transition ease-in-out duration-150"
                role="menuitem"
                >Logout</a
              >
            </div>
            <div class="text-white text-xs text-right">
              <div class="">version: {{ ver }}</div>
              <div class="">build: {{ hash }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Avatar from "@/components/elements/Avatar";

export default {
  name: "Profile",
  data() {
    return {
      isOpen: false
    };
  },
  components: {
    Avatar
  },
  props: {},
  computed: {
    hash() {
      return process.env.VUE_APP_GIT_HASH.substring(1);
    },
    ver(){
      return process.env.VUE_APP_VERSION;
    },
    ...mapState(["user", "notifications"])
  },
  methods: {
    logout() {
      this.$router.push('/logout');
    }
  }
};
</script>

<style scoped></style>
